import { render, staticRenderFns } from "./RowBlockActs.vue?vue&type=template&id=3db6c4e7&"
import script from "./RowBlockActs.vue?vue&type=script&lang=js&"
export * from "./RowBlockActs.vue?vue&type=script&lang=js&"
import style0 from "./RowBlockActs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports